import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Button = styled.button`
  display: flex;
  position: fixed;
  bottom: 24px;
  right: 32px;
  min-width: 209px;
  height: 48px;
  border-radius: 24px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 12px 40px 0px;
  padding: 12px 8px 12px 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  z-index: 100000;
  opacity: 0;
  animation: ${fadeInUp} 0.3s ease-in forwards;
  cursor: pointer;

  img {
    margin-left: 12px;
    align-self: center;
  }
`;
